import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import Theme from 'demo/components/template/Theme'
import Layout from 'demo/components/layout'
import history from './history'
import mockServer from './demo/mock'
import appConfig from 'demo/configs/app.config'
import './demo/locales'
import store, { persistor } from 'demo/store'
import httpService from 'services/http.service'
import CommonScrollToTop from 'common/common.scroll.to.top'

const environment = process.env.NODE_ENV

// if (appConfig.enableMock) {
//     mockServer({ environment })
// }

function App() {
    useEffect(() => {
        httpService.initializeInterceptors()
    }, [])

    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <BrowserRouter history={history}>
                    {/* Inside the router, so it can see the path change. */}
                    <CommonScrollToTop />
                    <Theme>
                        <Layout />
                    </Theme>
                </BrowserRouter>
            </PersistGate>
        </Provider>
    )
}

export default App
